<template>
    <div>
        <Header></Header>
        <b-container class="login-container">
            <div class="login-form" >
                <form @submit.prevent="login">  
                    <h4>{{'loginHead' | localize}}</h4>
                    <div><input
                        type="text"
                        class="form-control my-2"
                        v-model="user_login"
                        placeholder="Логин"
                    ></div>
                    <div 
                        class="form-description-error"
                        v-if="$v.user_login.$dirty && !$v.user_login.required"
                    >
                        {{'newAddressRequiredInput' | localize}}
                    </div>  
                    <div 
                        class="form-description-error"
                        v-if="$v.user_login.$dirty && !$v.user_login.minLength"
                    >
                        {{'userProfileMinSymbolsSix' | localize}}
                    </div>
                    <div class="my-2" style="position: relative">
                    <input
                        :type="passwordFieldType"
                        class="form-control"
                        v-model="password"
                        placeholder="Пароль"
                    >
                    <button @click.prevent.stop="showPassword" @submit.prevent="login" :class="passwordButtonState"><span>&nbsp;</span></button>
                    </div>
                    <div 
                        class="form-description-error"
                        v-if="$v.password.$dirty && !$v.password.required"
                    >
                        {{'newAddressRequiredInput' | localize}}
                    </div>  
                    <div 
                        class="form-description-error"
                        v-if="$v.password.$dirty && !$v.password.minLength"
                    >
                        {{'userProfileMinSymbolsSix' | localize}}
                    </div>  
                    <div 
                        class="form-description-error"
                        v-if="$v.password.$dirty && !$v.password.maxLength"
                    >
                        {{'newAddressMaxLengthSixteen' | localize}}
                    </div>  

                    <b-form-checkbox
                    class="mb-1"
                    id="checkbox-1"
                    v-model="save"
                    value="true"
                    unchecked-value="false"
                    > 
                        {{'loginSaveCheck' | localize}} 
                    </b-form-checkbox>

                    <button
                        id="send-message"
                        class="btn-entry mt-1"
                        type="submit"
                    >
                        {{'loginButton' | localize}}
                    </button>
                </form>
                <div class="recovery-pass mx-auto mt-3">
                    {{'loginForgotPass' | localize}}? 
                    <router-link
                        class="ml-1"
                        tag="strong"
                        :to="{name: 'RecoveryPass'}"
                    >
                        {{'loginForgotPassLink' | localize}}
                    </router-link>
                    
                </div>
            </div>
        </b-container>  
    </div> 
</template>
<script>
import base64url from "base64url";
import Header from '../components/Header'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import config from '@/config'
const ROUTE_PREFIX = config.ROUTE_PREFIX
export default {
    mixins: [validationMixin],
    data: ()=> ({
        passwordFieldType: "password",
        passwordButtonState: 'hide_password_button',
        user_login: '',
        password: '',
        user_info: null,
        save: false
    }),
    validations: {
        user_login: {
            required, 
            minLength: minLength(6),
            
        },
        password: { 
            required, 
            minLength: minLength(6),
            maxLength: maxLength(16),  
        },
    },
    computed: mapGetters(['userInfoData', 'locale']),
    mounted(){
        if(localStorage.weltInfo){
            this.user_login = JSON.parse(localStorage.weltInfo).login
            this.password = JSON.parse(localStorage.weltInfo).password
        }
    },
    methods: {
        showPassword(){
          if(this.passwordFieldType === 'password') {
            this.passwordFieldType = 'text'
            this.passwordButtonState = 'show_password_button'
          } else {
            this.passwordFieldType = 'password'
            this.passwordButtonState = 'hide_password_button'
          }
        },
        async login(){
          if(this.$v.$invalid){
            this.$v.$touch()
          } else {
           const loginData = {
             login: this.user_login,
             password: this.password
            }
            if(this.save === 'true'){
              localStorage.setItem('weltInfo',JSON.stringify(loginData))
            }
            await this.$store.dispatch('login', loginData) 

            this.user_info = this.userData
            if(this.userInfoData.items[0].err === "Забыли пароль ?"){
              this.$messageLocalized('wrongPassword')
              this.$store.dispatch('logout')

            } 
            else if(this.userInfoData.items[0].err === "Сессия уже открыта !"){
              this.$messageLocalized('sessionAlreadyOpened')
              this.$store.dispatch('logout')
            }
            else if(this.userInfoData.items[0].err === "Пользователь не существует !"){
              this.$messageLocalized('wrongLogin')
              this.$store.dispatch('logout')

            }
            else{
              localStorage.setItem('weltumPass', base64url(this.password) )

              if(localStorage.weltumLastUrl){
                  this.$router.push(`${localStorage.weltumLastUrl}`)
              } else{
                  this.$router.push(`${ROUTE_PREFIX}/`)
              }
            }
          }    
        }
    },
 components: { Header},
    
}
</script>
